module.exports = __webpack_public_path__ + "img/image01_sp.4934abf5.jpg";